import React from "react";
import logoutIcon from "../../base/assets/icons/logout.svg";
import styles from "./header.module.css";
import { useTranslation } from "react-i18next";
import { NavDropdown } from "react-bootstrap";

interface MenuLogoutDropDownPropsDI {
  name: string;
  onLogout: () => void;
}

const MenuLogoutDropDown: React.FC<MenuLogoutDropDownPropsDI> = (props) => {
  const { t } = useTranslation("");
  const handleLogout = () => props.onLogout();

  return (
    <NavDropdown
      title={props.name}
      id="basic-nav-dropdown2"
      renderMenuOnMount={true}
    >
      <NavDropdown.Item
        aria-label={t("Login-logout")}
        onClick={handleLogout}
        className={styles.navLink}
      >
        {t("Login-logout")}{" "}
        <img src={logoutIcon} className={styles.logoutIcon} />
      </NavDropdown.Item>
    </NavDropdown>
  );
};

export default MenuLogoutDropDown;
